///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import {
    AttachedFileDTO,
    BomConfigDTO,
    EngineExceptionDTO,
    HouseDetectionDTO,
    PlannerFeatureCollectionDTO,
    ProgressDTO,
    ProjectDesignConfigDTO,
    ProjectUserSessionDTO
} from '../../generated/shared-types.model';
import { GtthNodeFeatureDtoModel } from './dto/gtth-node-feature-dto.model';
import { GtthLinkFeatureDtoModel } from './dto/gtth-link-feature-dto.model';

export class ActivityDTO {
    constructor(
        public commandId: number,
        public commandName: string,
        public userLogin: string,
        public uiBroadcast: boolean,
        public doCommand: boolean,
        public doLocally: boolean,
        public successful?: boolean,
        public interrupted?: boolean,
        public commandNameToTerminate?: string,
        public logicalTopology?: PlannerFeatureCollectionDTO,
        public nodes?: GtthNodeFeatureDtoModel[],
        public links?: GtthLinkFeatureDtoModel[],
        public attachedFile?: AttachedFileDTO,
        public previousDesignIterationNumber?: number,
        public designIterationNumber?: number,
        public error?: EngineExceptionDTO,
        public sessionId?: string,
        public oldSessionId?: string,
        public enableBasicReports?: boolean,
        public houseDetectionConfig?: HouseDetectionDTO,
        public progress?: ProgressDTO,
        public bomConfig?: BomConfigDTO,
        public userSession?: ProjectUserSessionDTO,
        public topologyChanged?: boolean,
        public forceClearCache?: boolean,
        public designConfig?: ProjectDesignConfigDTO
    ) {}
}
